<template>
	<v-container grid-list-md>
		<v-layout wrap row>
			<v-flex xs12 md8>
				<v-layout wrap row>
					<v-flex xs12>
						<form-localized-input
							v-model="item.title"
							label="Title"
							placeholder="Title"
						></form-localized-input>
					</v-flex>
					<v-flex xs12>
						<v-subheader class="font-weight-bold">
							Opening Time
						</v-subheader>
						<v-row>
							<v-col>
								<v-menu
									ref="start_time_menu"
									v-model="start_time"
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="item.start_time"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="item.start_time"
											label="Start Time"
											prepend-icon="mdi-clock-time-four-outline"
											readonly
											v-bind="attrs"
											v-on="on"
										></v-text-field>
									</template>
									<v-time-picker
										v-if="start_time"
										v-model="item.start_time"
										full-width
										@click:minute="
											$refs.start_time_menu.save(
												item.start_time
											)
										"
										:max="item.end_time"
									></v-time-picker>
								</v-menu>
							</v-col>
							<v-col>
								<v-menu
									ref="end_time_menu"
									v-model="end_time"
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="item.end_time"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="item.end_time"
											label="End Time"
											prepend-icon="mdi-clock-time-four-outline"
											readonly
											v-bind="attrs"
											v-on="on"
										></v-text-field>
									</template>
									<v-time-picker
										v-if="end_time"
										v-model="item.end_time"
										full-width
										@click:minute="
											$refs.end_time_menu.save(
												item.end_time
											)
										"
										:min="item.start_time"
									></v-time-picker>
								</v-menu>
							</v-col>
						</v-row>
					</v-flex>
					<v-flex xs12>
						<v-subheader class="font-weight-bold">
							Availability
						</v-subheader>
						<v-row no-gutters>
							<v-col>
								<v-checkbox
									v-model="item.monday"
									:label="'Monday'"
								></v-checkbox
							></v-col>
							<v-col>
								<v-checkbox
									v-model="item.tuesday"
									:label="'Tuesday'"
								></v-checkbox
							></v-col>
							<v-col>
								<v-checkbox
									v-model="item.wednesday"
									:label="'Wednesday'"
								></v-checkbox
							></v-col>
							<v-col>
								<v-checkbox
									v-model="item.thursday"
									:label="'Thursday'"
								></v-checkbox
							></v-col>
							<v-col>
								<v-checkbox
									v-model="item.friday"
									:label="'Friday'"
								></v-checkbox
							></v-col>
							<v-col>
								<v-checkbox
									v-model="item.saturday"
									:label="'Saturday'"
								></v-checkbox
							></v-col>
							<v-col>
								<v-checkbox
									v-model="item.sunday"
									:label="'Sunday'"
								></v-checkbox
							></v-col>
						</v-row>
					</v-flex>
					<v-flex x12>
						<form-localized-editor
							v-model="item.description"
							label="Description"
							placeholder="Description"
						></form-localized-editor>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4 class="pl-5">
				<v-card>
					<v-card-title>Outlet</v-card-title>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<ValidationProvider
									name="outlet_id"
									rules="required"
									v-slot="{ errors }"
								>
									<v-select
										:items="outlets"
										v-model="item.outlet_id"
										:label="$__('Please choose outlet')"
										item-value="id"
										item-text="name"
										:error-messages="errors"
									></v-select>
								</ValidationProvider>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
				<p>&nbsp;</p>
				<v-card>
					<v-card-title>Settings</v-card-title>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12 md12>
								<v-switch
									v-model="item.settings.delivery_module"
									:label="$t('Delivery Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md12>
								<v-switch
									v-model="item.settings.pickup_module"
									:label="$t('Pickup Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md12>
								<v-switch
									v-model="item.settings.dine_in_module"
									:label="$t('Dinein Module')"
								></v-switch>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	name: "ShopFormCatalogue",

	props: ["value", "outlets"],

	data() {
		return {
			start_time: false,
			end_time: false,
		};
	},

	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>